import { Activity } from 'lucide-react';

import loginGif from '../../../../assets/image/aa.gif';

const LoginHeader = () => {
  return (
    <div
      className="
        mb-[clamp(0.75rem,1.5vw,1.5rem)]
        w-full
      "
    >
      {/* Badge */}
      <div className="flex justify-center">
        <div
          className="
            inline-flex
            items-center

            gap-[clamp(0.3rem,0.5vw,0.5rem)]

            rounded-full

            border
            border-blue-100

            bg-blue-50

            px-[clamp(0.5rem,0.8vw,0.75rem)]
            py-[clamp(0.3rem,0.5vw,0.5rem)]
          "
        >
          <Activity
            size={14}
            className="
              shrink-0
              animate-pulse
              text-blue-600
            "
          />

          <span
            className="
              text-[clamp(8px,0.7vw,12px)]

              font-semibold

              uppercase

              tracking-[clamp(0.12em,0.2vw,0.25em)]

              text-blue-700

              whitespace-nowrap
            "
          >
            SAGILITY • WORKVISTA
          </span>
        </div>
      </div>

      {/* Heading */}
      <div
        className="
          mt-[clamp(0.75rem,1vw,1rem)]
          text-center
        "
      >
        <h1
          className="
            text-[clamp(22px,2vw,30px)]

            font-black
            leading-tight

            text-slate-800
          "
        >
          Welcome Back
        </h1>
      </div>

      {/* Animated GIF */}
      <div
        className="
          mt-[clamp(0.75rem,1.2vw,1.25rem)]

          flex
          justify-center
        "
      >
        <img
          src={loginGif}
          alt="WorkVista Animation"
          className="
            w-[clamp(130px,15vw,240px)]

            max-w-[70%]

            rounded-2xl

            object-contain

            shadow-xl
          "
        />
      </div>

      {/* Description */}
      <div
        className="
          mt-[clamp(0.65rem,1vw,1rem)]

          text-center
        "
      >
        <p
          className="
            mx-auto

            max-w-[380px]

            text-[clamp(10px,0.85vw,14px)]

            leading-[clamp(1rem,1.4vw,1.5rem)]

            text-slate-500
          "
        >
          Intelligent workforce monitoring with
          real-time productivity insights.
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;